import type { ReactNode } from 'react'

import { cn } from '@/utils'
import { Card } from './Card'
import { FigureLabel } from './FigureLabel'
import { FigureValue } from './FigureValue'

interface FigureCardProps {
  label: string
  value: ReactNode
  valueClassName?: string
}

export const FigureCard = ({
  label,
  value,
  valueClassName,
}: FigureCardProps) => (
  <Card className="p-6">
    <FigureLabel>{label}</FigureLabel>
    <FigureValue className={cn('mt-1', valueClassName)}>{value}</FigureValue>
  </Card>
)
